import { cva, type VariantProps } from 'class-variance-authority';

export const typeaheadVariants = cva(
  'w-full text-lg font-bold leading-none text-gray-700 transition-all placeholder:text-gray-300',
  {
    variants: {
      variant: {
        primary:
          'py-c md:py-b pl-b pr-e placeholder-shown:pr-b text-ellipsis focus:text-gray-700 rounded-md border-0 text-center ring-1 ring-inset ring-pink-500 hover:ring-2 focus:ring-2 outline-none leading-none focus:outline-none focus:ring-inset focus:ring-pink-600 hover:text-gray-700',
        secondary:
          'pl-0 pr-e placeholder-shown:pr-b text-ellipsis py-c md:py-b  focus:outline-0 focus:ring-0 border-t-0 border-x-0 border-b-2 text-left border-b-pink-500 focus:border-b-pink-600',
        disabled:
          'pl-0 pr-e placeholder-shown:pr-b text-ellipsis py-c md:py-b focus:outline-0 focus:ring-0 border-t-0 border-x-0 border-b-2 text-left ',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
);

export type TypeaheadVariants = VariantProps<typeof typeaheadVariants>;
